import { createContext } from "react";

const modalNoteState = createContext();

export default modalNoteState;
